import React, { useState } from 'react';
import './DeepInsightsMessageAddons.css';
import chevronDownIcon from '../../assets/new-images/dropdown-icon.svg';
import paperclipIcon from '../../assets/new-images/feather-paperclip-icon.svg';
import refreshPaperclipIcon from '../../assets/new-images/refresh-paperflip-icon.svg';
import { useConstants } from '../../constant/constantProvider';

const DeepInsightsMessageAddons = ({ sources = [], followUpQuestions = [], onFollowUpClick, disabled = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { SOURCES, SUGGESTED_FOLLOW_UPS, NEWS, INTERNAL, REPORT } = useConstants();

  if ((!sources || sources.length === 0) && (!followUpQuestions || followUpQuestions.length === 0)) return null;

  return (
    <div className="di-sources-and-followups">
      {sources && sources.length > 0 && (
        <div className="di-sources-container">
          <button 
            className={`di-sources-header ${isExpanded ? 'expanded' : ''}`}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <div className="di-sources-header-left">
              <img src={paperclipIcon} alt="sources" className="di-sources-icon" />
              <span className="di-sources-title">{SOURCES}</span>
              <span className="di-sources-count">{sources.length}</span>
            </div>
            <img 
              src={chevronDownIcon} 
              alt="toggle" 
              className={`di-sources-chevron ${isExpanded ? 'rotated' : ''}`} 
            />
          </button>

          {isExpanded && (
            <div className="di-sources-list">
              {sources.map((source, idx) => {
                const displayText = source.title || source.label || `Source ${source.index || idx + 1}`;
                const displayUrl = source.url || "";
                // Determine badge text based on properties or defaults if we can't infer
                let badgeText = "";
                if (source.type) {
                  badgeText = source.type.toUpperCase();
                } else if (source.title) {
                  badgeText = NEWS.toUpperCase();
                } else if (displayUrl.includes("internal")) {
                  badgeText = INTERNAL.toUpperCase();
                } else {
                  badgeText = REPORT.toUpperCase();
                }

                return (
                  <div key={idx} className="di-source-item">
                    <div className="di-source-index">
                      {source.index || idx + 1}
                    </div>
                    <div className="di-source-content">
                      <div className="di-source-text">{displayText}</div>
                      {displayUrl && (
                        <a href={displayUrl} target="_blank" rel="noopener noreferrer" className="di-source-url">
                          {displayUrl}
                        </a>
                      )}
                    </div>
                    {badgeText && (
                      <div className="di-source-badge">
                        {badgeText}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {followUpQuestions && followUpQuestions.length > 0 && (
        <div className="di-followups-container">
          <div className="di-followups-header">
            <img src={refreshPaperclipIcon} alt="follow-ups" className="di-followups-icon" />
            <span>{SUGGESTED_FOLLOW_UPS}</span>
          </div>
          <div className="di-followups-list">
            {followUpQuestions.map((question, idx) => (
              <button 
                key={idx} 
                className="di-followup-pill"
                disabled={disabled}
                onClick={() => !disabled && onFollowUpClick && onFollowUpClick(question)}
              >
                {question}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeepInsightsMessageAddons;
